import { createContext } from 'react'

const VisualizerSetterContext = createContext()

export default VisualizerSetterContext
